import React, { useEffect, useState } from 'react';
import Lenis from 'lenis';
import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import About from '@/components/site/About';
import Team from '@/components/site/Team';
import Services from '@/components/site/Services';
import WhyUs from '@/components/site/WhyUs';
import ProjectsGrowth from '@/components/site/ProjectsGrowth';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import ApplicationDialog from '@/components/site/ApplicationDialog';

export default function Landing() {
  const [applyOpen, setApplyOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);

    // Support hash-scroll arriving from other routes
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 400);
    }

    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  return (
    <div className="bg-white">
      <Header onApply={() => setApplyOpen(true)} />
      <main>
        <Hero onApply={() => setApplyOpen(true)} />
        <About />
        <Team />
        <Services />
        <WhyUs />
        <ProjectsGrowth />
        <Contact />
      </main>
      <Footer onApply={() => setApplyOpen(true)} />
      <ApplicationDialog open={applyOpen} onOpenChange={setApplyOpen} />
    </div>
  );
}
